import React from "react";
import SubBlogs from "../SubBlogs";
import "./style.scss";
import { useBlogList, useSuccessStories } from "hooks/api/useHome";
import Skeleton from "components/BaseWidgets/skeleton";
import EmptyState from "components/BaseWidgets/emptyState";

function MoreBlogs({
  isSuccessView = false,
  currentBlogId,
  requestType,
  currentStoryId,
}) {
  //more blogs listing
  const { data: blogs, isLoading: isBlogLoading } = useBlogList(
    {
      see_all: true,
      request_type: requestType,
      exclude_id: currentBlogId,
    },
    {
      enabled: !!currentBlogId && !isSuccessView,
    },
  );

  //more success stories listing
  const { data: moreStories, isLoading: moreStoriesLoading } =
    useSuccessStories(
      {
        see_all: true,
        id: currentStoryId,
      },
      {
        enabled: !!currentStoryId && isSuccessView,
      },
    );

  const mappedBlogs = blogs?.blog_data?.map((blog) => ({
    id: blog?.id,
    title: blog.head,
    info: blog.body,
    blogcover: blog.image,
    authorPic: blog.blog_written_by_image,
    author: blog.blog_written_by_name,
    blogTime: blog.time,
    blogLikes: blog.total_likes,
    blogDislikes: blog.total_dislikes,
    description: blog.body,
    name: blog.blog_written_by_name,
  }));

  const mappedStories = moreStories?.map((story) => {
    const userFirstName = story.user?.first_name || "";
    const partnerFirstName = story.partner?.first_name || "";
    return {
      id: story.id,
      name: `${userFirstName} & ${partnerFirstName}`,
      blogTime: story.created_at
        ? new Date(story.created_at).toISOString().split("T")[0]
        : "",
      description: story.body,
      blogcover: story.images?.[0]?.image || "",
    };
  });

  const finalData = isSuccessView ? mappedStories : mappedBlogs;
  const isLoading = isSuccessView ? moreStoriesLoading : isBlogLoading;

  return (
    <div className="more-blog-area">
      <span className="font-title-lg fw-700 more-blog-heading">
        {isSuccessView ? "More Stories" : "More Blogs"}
      </span>
      <div className="more-blog-list">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} label={false} height={150} />
          ))
        ) : finalData?.length ? (
          finalData.map((eachItem, index) => (
            <SubBlogs key={index} EachBlogs={eachItem} isTrue={isSuccessView} />
          ))
        ) : (
          <EmptyState
            message={
              isSuccessView ? "No more stories found!" : "No more blogs found!"
            }
            className="overview-empty"
          />
        )}
      </div>
    </div>
  );
}

export default MoreBlogs;
